/** Production hosted checkout origin loaded in the modal iframe. */
export const DEFAULT_CHECKOUT_URL = "https://checkout.borga.is";
